var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFlow = function SvgFlow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.2 147.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-6,.cls-7{fill:none;stroke-width:2px;}.cls-1,.cls-7{stroke:#404041}.cls-1,.cls-2,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-6{stroke:#404041}.cls-3{fill:#404041;}.cls-4{fill:#FFCB04;}.cls-5{fill:#FFCB04;}.cls-6,.cls-7{stroke-linecap:round;}.cls-7{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Simple Workflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Software"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,132.67V78.43a5,5,0,0,1,5-5h147.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.52,
    y1: 127.39,
    x2: 98.63,
    y2: 127.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "68.75 147.25 98.63 104.99 128.52 147.25 68.75 147.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 104.99,
    width: 42.27,
    height: 42.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.5,
    width: 42.27,
    height: 42.27,
    rx: 21.13,
    ry: 21.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.63,22.28h70.56a5.58,5.58,0,0,1,5.58,5.58V63.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.13,
    y1: 22.28,
    x2: 77.5,
    y2: 22.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 1.15,
    width: 42.27,
    height: 42.27,
    rx: 21.13,
    ry: 21.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 152.93,
    y: 52.32,
    width: 42.27,
    height: 42.27
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "56.13 15.04 63.37 22.28 56.13 29.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "58.6 120.14 65.85 127.39 58.6 134.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "182.02 40.67 174.78 47.92 167.53 40.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "182.02 32.13 174.78 39.38 167.53 32.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "28.38 87.76 21.13 95 13.89 87.76"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFlow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";